import { render, staticRenderFns } from "./tanchiLeaderboard.vue?vue&type=template&id=868b46a8&scoped=true&"
import script from "./tanchiLeaderboard.vue?vue&type=script&lang=js&"
export * from "./tanchiLeaderboard.vue?vue&type=script&lang=js&"
import style0 from "./tanchiLeaderboard.vue?vue&type=style&index=0&id=868b46a8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "868b46a8",
  null
  
)

/* custom blocks */
import block0 from "./tanchiLeaderboard.vue?vue&type=custom&index=0&blockType=route"
if (typeof block0 === 'function') block0(component)

export default component.exports